/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SpaceEligibilityRpc
 */
import * as References from './SpaceEligibilityRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SpaceEligibilityRpc#listCreatableSpaces
 */
export const LIST_CREATABLE_SPACES_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_SpaceEligibilityRpc_listCreatableSpaces';
export const LIST_CREATABLE_SPACES_QUERY: RegisteredQuery<
  'result',
  References.ListCreatableSpacesRequestType,
  References.ListCreatableSpacesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_CREATABLE_SPACES_QUERY_FIELD_NAME,
  args: [
    'domain',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.ListCreatableSpacesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListCreatableSpacesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listCreatableSpacesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
